import { Route, Switch } from 'react-router';
import ViewHomeDistricts from './view';
import CreateHomeDistrict from './create';
import EditHomeDistrict from './edit';

/**
 * Router switch for home districts admin page
 */
const HomeDistricts = () => {
  return (
    <Switch>
      <Route exact path='/admin/homeDistricts' component={ViewHomeDistricts} />
      <Route exact path='/admin/homeDistricts/new' component={CreateHomeDistrict} />
      <Route exact path='/admin/homeDistricts/:id' component={EditHomeDistrict} />
    </Switch>
  );
};

export default HomeDistricts;
